var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var VisualParams_1;
import { AggregateColumn } from '@symon-ai/wisepipe-base-pipe';
import '@symon-ai/wisepipe-common-pipe'; // force import for JsonSchemaV2
import { SortColumn } from '@symon-ai/wisepipe-common-pipe';
import { JSON, JsonConverter, JsonDiscriminatorProperty, JsonSchemaV2, MapConverter } from '@symon-ai/wisepipe-serialize';
import { squel } from '@symon-ai/wisepipe-squel';
import './filter'; // force import for JsonSchemaV2
import { VisualType } from '@symon-ai/wisepipe-base-computation';
import { visualParamsSchemaValidation } from '../validations.generated';
export var Overflow;
(function (Overflow) {
    Overflow["Truncate"] = "truncate";
    Overflow["Break"] = "break";
    Overflow["BreakAll"] = "breakAll";
})(Overflow || (Overflow = {}));
export const visualParamsSchema = {
    $id: 'urn:wisepipe-common-computation:VisualParams',
    type: 'object',
    properties: {
        visualType: { type: 'string', enum: Object.values(VisualType) },
        sortDir: { type: 'string', enum: [SortColumn.SortDirection.ASCENDING, SortColumn.SortDirection.DESCENDING] },
        showTitle: { type: 'boolean' },
        showSubTitle: { type: 'boolean' },
        subTitle: { type: 'string' },
        xTitleName: { type: 'string' },
        xTitleShow: { type: 'boolean' },
        xAxisLabelAngle: { type: 'number' },
        yTitleName: { type: 'string' },
        yTitleShow: { type: 'boolean' },
        yAxisLabelAngle: { type: 'number' },
        yRightTitle: { type: 'string' },
        yRightShow: { type: 'boolean' },
        yRightAxisLabelAngle: { type: 'number' },
        legendShow: { type: 'boolean' },
        legendSubcatShow: { type: 'boolean' },
        legendTop: { type: 'string' },
        legendLeft: { type: 'string' },
        gradient: { type: 'boolean' },
        shadow: { type: 'boolean' },
        colorMap: {
            type: 'object',
            additionalProperties: { type: 'string' }
        },
        sortColumns: {
            // sort on selected columns
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-pipe:SortColumn' },
            minItems: 1,
            uniqueItemProperties: ['name']
        },
        spacing: {
            // spacing around chart
            type: 'object',
            properties: {
                left: { type: ['number', 'null'] },
                right: { type: ['number', 'null'] },
                top: { type: ['number', 'null'] },
                bottom: { type: ['number', 'null'] }
            }
        },
        overflow: { type: 'string', enum: Object.values(Overflow) },
        filters: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-computation:Filter' },
            maxItems: 20
        }
    },
    required: ['visualType']
};
let VisualParams = VisualParams_1 = class VisualParams {
    constructor(args) {
        this.visualType = args.type;
        if (args.sortDir !== undefined)
            this.sortDir = args.sortDir;
        if (args.showTitle !== undefined)
            this.showTitle = args.showTitle;
        if (args.showSubTitle !== undefined)
            this.showSubTitle = args.showSubTitle;
        if (args.subTitle !== undefined)
            this.subTitle = args.subTitle;
        if (args.xTitleName !== undefined)
            this.xTitleName = args.xTitleName;
        if (args.xTitleShow !== undefined)
            this.xTitleShow = args.xTitleShow;
        if (args.xAxisLabelAngle !== undefined)
            this.xAxisLabelAngle = args.xAxisLabelAngle;
        if (args.yTitleName !== undefined)
            this.yTitleName = args.yTitleName;
        if (args.yTitleShow !== undefined)
            this.yTitleShow = args.yTitleShow;
        if (args.yAxisLabelAngle !== undefined)
            this.yAxisLabelAngle = args.yAxisLabelAngle;
        if (args.yRightTitle !== undefined)
            this.yRightTitle = args.yRightTitle;
        if (args.yRightShow !== undefined)
            this.yRightShow = args.yRightShow;
        if (args.yRightAxisLabelAngle !== undefined)
            this.yRightAxisLabelAngle = args.yRightAxisLabelAngle;
        if (args.legendShow !== undefined)
            this.legendShow = args.legendShow;
        if (args.legendSubcatShow !== undefined)
            this.legendSubcatShow = args.legendSubcatShow;
        if (args.legendTop !== undefined)
            this.legendTop = args.legendTop;
        if (args.legendLeft !== undefined)
            this.legendLeft = args.legendLeft;
        if (args.colorMap !== undefined)
            this.colorMap = args.colorMap;
        if (args.sortColumns !== undefined)
            this.sortColumns = args.sortColumns;
        if (args.spacing !== undefined)
            this.spacing = args.spacing;
        if (args.overflow !== undefined)
            this.overflow = args.overflow;
        if (args.filters !== undefined)
            this.filters = args.filters;
        if (args.gradient !== undefined)
            this.gradient = args.gradient;
        if (args.shadow !== undefined)
            this.shadow = args.shadow;
        JSON.validate(this, VisualParams_1);
    }
    static getAggSource(name, op, type) {
        if (type !== 'number' && type !== 'boolean' && op !== AggregateColumn.Operation.COUNT) {
            throw new Error(`Aggregate operation ${op} not supported on column (${name}:${type})`);
        }
        if (type === 'boolean' &&
            (op === AggregateColumn.Operation.SUM ||
                op === AggregateColumn.Operation.AVERAGE ||
                op === AggregateColumn.Operation.MEDIAN)) {
            throw new Error(`Aggregate operation ${op} not supported on column (${name}:${type})`);
        }
        let expr = `${op}("${name}")`;
        if (op === AggregateColumn.Operation.COUNT) {
            expr = `cast(${expr} as int)`;
        }
        else if (op === AggregateColumn.Operation.SUM) {
            expr = `if(typeof(${expr}) = 'bigint', cast(${expr} as int), cast(${expr} as double))`;
        }
        else if (op === AggregateColumn.Operation.MEDIAN) {
            expr = `approx_percentile("${name}", 0.5)`;
        }
        else if (op === AggregateColumn.Operation.AND) {
            expr = `MIN("${name}")`;
        }
        else if (op === AggregateColumn.Operation.OR) {
            expr = `MAX("${name}")`;
        }
        return squel.expr().or(expr);
    }
    getQuery(query, types, tableName) {
        const visualQuery = squel.select({ autoQuoteFieldNames: false }).from(squel.expr().or(query.toParam().text));
        const fields = this.getFields();
        const groupByCols = [];
        const aliasMap = new Map();
        let hasAggregates = false;
        for (const f of fields) {
            let source;
            if (f.aggOp !== undefined) {
                hasAggregates = true;
                source = VisualParams_1.getAggSource(f.source, f.aggOp, types.get(f.source));
            }
            else {
                source = `"${f.source}"`;
                groupByCols.push(source);
            }
            // table visual tool type supports decimal rounding for each column
            if (f.decimals !== undefined && types.get(f.source) === 'number') {
                source = squel.expr().or(`ROUND(${source}, ${f.decimals})`);
            }
            visualQuery.field(source, f.alias, { ignorePeriodsForFieldNameQuotes: true });
            // use last column if duplicate column names
            aliasMap.set(f.source, f.alias);
        }
        if (hasAggregates) {
            // heatmap tool has aggOp property now and it has two group by cols whereas other visual
            // tool types with aggOp has one group by col.
            groupByCols.forEach((source) => {
                visualQuery.group(source);
            });
        }
        // sortColumn for table tool type, sortDir for other visual tool types
        if (this.sortColumns !== undefined) {
            this.sortColumns.forEach((sc) => {
                // TODO: YI: update once RL calc is in
                const alias = aliasMap.get(sc.name);
                if (alias !== undefined) {
                    visualQuery.order(`"${alias}"`, sc.direction === SortColumn.SortDirection.ASCENDING);
                }
            });
        }
        else if (this.sortDir !== undefined) {
            visualQuery.order(`"${fields[0].alias}"`, this.sortDir === SortColumn.SortDirection.ASCENDING);
        }
        return this.setFinalQuery(visualQuery, types.get(fields[0].source), tableName);
    }
};
__decorate([
    JsonConverter(new MapConverter())
], VisualParams.prototype, "colorMap", void 0);
VisualParams = VisualParams_1 = __decorate([
    JsonSchemaV2(visualParamsSchema, visualParamsSchemaValidation),
    JsonDiscriminatorProperty('visualType')
], VisualParams);
export { VisualParams };
//# sourceMappingURL=visualParams.js.map